export default __webpack_public_path__ + "static/media/07_BUKAVU-min.bc1c325d.jpg";